export const MONTH_YEAR = 'MMMM YYYY';
export const JSON_DATE_TIME = 'yyyy-MM-dd\'T\'HH:mm:ss';
export const SLASHED_US_DATE_FORMAT = 'MM/DD/YYYY';
export const MONTH_DATE_FORMAT = 'MM/DD';